import { render, staticRenderFns } from "./CreateFAQ.vue?vue&type=template&id=2a160996&"
import script from "./CreateFAQ.vue?vue&type=script&lang=js&"
export * from "./CreateFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports